module.exports = __webpack_public_path__ + "img/menu-icon-privacy-policy-circle.4001f6d5.svg";